import React from 'react';
import axios from 'axios';
import history from 'history.js';
import localStorageService from './localStorageService';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
export const paymentUrl = process.env.REACT_APP_PAYMENT_URL;

export const parseTimeStampToDate = transactionList => {
  let result = transactionList.map(obj => ({ ...obj, date: Date.parse(obj.timestamp.replace(' +0000', '+00:00').replace(' ', 'T')) }));
  return result;
};

export const check401 = async error => {
  if (error === undefined) return;
  if (error.response === undefined) return;

  if (error.response.status === 401) {
    history.push({ pathname: '/session/signin' });
  }
};
export const formatError = async error => {
  if (error.response === undefined) {
    return { error: error, status: 400, data: error };
  }
  return error.response;
};
export const getSettledList = async merchantId => {
  try {
    const response = await axios.get(`/api/payments/merchant/${merchantId}/settled/1`);
    return response;
  } catch (error) {
    check401(error);
    return error.response;
  }
};

export const getSalesReport = async merchantId => {
  try {
    const response = await axios.get(`/api/payments/merchant/${merchantId}/settled/report/12`);
    return response;
  } catch (error) {
    check401(error);
    return error.response;
  }
};

export const getVoidList = async merchantId => {
  try {
    const response = await axios.get(`/api/payments/merchant/${merchantId}/unsettled/1`);
    return response;
  } catch (error) {
    check401(error);
    return error.response;
  }
};

export const getUnsettledTransactions = async (merchantId, monthsBack = 1) => {
  try {
    const response = await axios.get(`/api/payments/merchant/${merchantId}/unsettled/streaming/${monthsBack}`);
    return response;
  } catch (error) {
    check401(error);
    return error.response;
  }
};

export const getProfile = async () => {
  const response = await axios.get('/api/profile');
  return response;
};

export const getMerchantProfile = async merchantId => {
  const response = await axios.get('/api/profile/' + merchantId);
  return response;
};

export const updateProfile = async params => {
  const response = await axios.post('/api/profile', params);
  return response;
};

export const updateMerchantProfile = async (merchantId, params) => {
  try {
    const response = await axios.post('/api/profile/' + merchantId, params);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const requestUsername = async params => {
  try {
    const response = await axios.post('/api/auth/usernames', params);
    return response;
  } catch (error) {
    return error;
  }
};

export const requestPasswordReset = async params => {
  try {
    const response = await axios.post('/api/auth/passwordreset', params);
    return response;
  } catch (error) {
    return error;
  }
};

export const resetPassword = async params => {
  try {
    const response = await axios.put('/api/auth/passwordreset', params);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createMerchant = async params => {
  try {
    const response = await axios.post('/api/admin/merchants', params);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const updateMerchant = async (params, id) => {
  try {
    const response = await axios.put('/api/admin/merchants/' + id, params);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deleteMerchant = async id => {
  try {
    const response = await axios.delete('/api/admin/merchants/' + id);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const enableMerchant = async id => {
  try {
    const response = await axios.post('/api/admin/merchants/enable/' + id);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getMerchants = async search => {
  try {
    const brand = localStorageService.getItem('brandReducer');
    const response = await axios.get('/api/admin/merchants/' + brand.key + '/search/' + encodeURIComponent(search));
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getMerchantsNoTerms = async () => {
  try {
    const brand = localStorageService.getItem('brandReducer');
    const response = await axios.get('/api/admin/merchants/' + brand.key + '/terms/never/');
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getMerchantsWithTerms = async () => {
  try {
    const brand = localStorageService.getItem('brandReducer');
    const response = await axios.get('/api/admin/merchants/' + brand.key + '/terms/accepted/');
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getMerchant = async id => {
  try {
    const response = await axios.get('/api/admin/merchants/' + id);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const sendWelcomeEmail = async id => {
  try {
    const response = await axios.post('/api/admin/merchants/email/welcome/' + id);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const acceptTerms = async request => {
  try {
    const response = await axios.post('/api/profile/terms/', request);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getFailedTransactions = async (merchantId, monthsBack = 1) => {
  try {
    const response = await axios.get(`/api/payments/merchant/${merchantId}/failed/streaming/${monthsBack}`);
    return response;
  } catch (error) {
    check401(error);
    return error.response;
  }
};

export const getSettledTransactions = async (merchantId, monthsBack = 1) => {
  try {
    const response = await axios.get(`/api/payments/merchant/${merchantId}/settled/streaming/${monthsBack}`);
    return response;
  } catch (error) {
    check401(error);
    return error.response;
  }
};

export const getPaymentDetails = async (merchantId, paymentId) => {
  try {
    const response = await axios.get(`/api/payments/merchant/${merchantId}/${paymentId}`);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getCaptchaDetails = async (merchantId, paymentId) => {
  try {
    const response = await axios.get(`/api/fraud/captcha/${merchantId}/${paymentId}`);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const markPaymentLegit = async (merchantId, paymentId, recaptchaId) => {
  axios.defaults.baseURL = paymentUrl;
  try {
    const response = await axios.post(`/fraud/annotate.php`, {
      token: localStorage.getItem('jwt_token'),
      eventType: 'LEGIT',
      ttid: paymentId,
      merchantId,
      recaptcha_assessment_name: recaptchaId
    });
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    return response;
  } catch (error) {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    return error.response;
  }
};

export const markPaymentFraud = async (merchantId, paymentId, recaptchaId) => {
  axios.defaults.baseURL = paymentUrl;
  try {
    const response = await axios.post(`/fraud/annotate.php`, {
      token: localStorage.getItem('jwt_token'),
      eventType: 'FRAUD',
      ttid: paymentId,
      merchantId,
      recaptcha_assessment_name: recaptchaId
    });
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    return response;
  } catch (error) {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    return error.response;
  }
};

export const voidPayment = async (merchantId, paymentId, reverse = false) => {
  try {
    const reqOptions = {
      url: `/api/payments/merchant/${merchantId}/${paymentId}`,
      method: 'DELETE',
      headersList: {
        'Content-Type': 'application/json'
      },
      data: { action: reverse ? 'reversal' : 'void' }
    };

    const response = await axios.request(reqOptions);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const returnPayment = async (merchantId, transactionId, payload) => {
  try {
    const response = await axios.post(`/api/payments/merchant/${merchantId}/return/${transactionId}`, payload);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const preAuthComplete = async (merchantId, params) => {
  try {
    const response = await axios.patch(`/api/payments/merchant/${merchantId}/${params.ttid}`, params);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const settle = async merchantId => {
  try {
    const response = await axios.post(`/api/payments/merchant/${merchantId}/settle`);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const useSettle = () => {
  const [{ submitting }, setState] = React.useState({ submitting: false });
  const handleSettle = React.useCallback(
    ({ merchantId, onSuccess = undefined, onError = undefined }) => {
      setState({ submitting: true });
      settle(merchantId)
        .then(response => {
          if (response.status !== 200) {
            setState({ submitting: false });
            onError && onError(response);
          } else {
            //let result = parseTimeStampToDate(response.data);
            //result.forEach(element => {
            //  element.expdate = element.expdate ? getFormatedExpiryDate(element.expdate) : '';
            //});
            onSuccess && onSuccess(response.data);
            setState({ submitting: false });
          }
        })
        .catch(error => {
          onError && onError(error);
        });
    },
    [setState]
  );
  return {
    submitting,
    handleSettle
  };
};

export const emailReceipt = async (merchantId, transactionId, email) => {
  try {
    const response = await axios.post(`/api/payments/merchant/${merchantId}/email/receipt/${transactionId}`, { email });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getConversions = async merchantId => {
  try {
    const response = await axios.get('/api/admin/merchants/convert/' + merchantId);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const postConversion = async request => {
  try {
    const response = await axios.post('/api/admin/merchants/convert', request);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getApiKeys = async merchantId => {
  try {
    const response = await axios.get('/api/profile/apikeys/' + merchantId);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deleteApiKey = async (merchantId, apiKeyId) => {
  try {
    const response = await axios.delete('/api/profile/apikeys/' + merchantId + '/' + apiKeyId);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createApiKey = async request => {
  try {
    const response = await axios.post('/api/profile/apikeys', request);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getResellers = async () => {
  try {
    const brand = localStorageService.getItem('brandReducer');
    const response = await axios.get('/api/admin/merchants/' + brand.key + '/resellers');
    return response;
  } catch (error) {
    return error.response;
  }
};
export const getFeeItemList = async () => {
  try {
    const response = await axios.get('/api/admin/fees');
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getPricingTiers = async () => {
  try {
    const response = await axios.get(`/api/admin/reseller/tiers`);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const activatePricingTier = async (resellerId, pricingTierId) => {
  try {
    const response = await axios.put(`/api/admin/reseller/tiers/${resellerId}/activate`, { id: pricingTierId });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const processPricingTier = async (resellerId, params, action = 'put') => {
  try {
    const axiosAction = action === 'post' ? axios.post : axios.put; // Create or update
    const response = await axiosAction('api/admin/reseller/tiers/' + resellerId, params);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getFeeTypes = async resellerId => {
  try {
    const response = await axios.get(`/api/admin/resellers/fees/${resellerId}`);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getResellerPricingTiers = async resellerId => {
  try {
    const response = await axios.get(`/api/admin/reseller/tiers/${resellerId}`);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getAvailableResellerFeeItemList = async merchantId => {
  try {
    const response = await axios.get('/api/admin/merchants/fees/available/' + merchantId);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const getMerchantFeeItemList = async merchantId => {
  try {
    const response = await axios.get('/api/admin/merchants/fees/' + merchantId);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getMerchantProfileFeeItemList = async () => {
  try {
    const response = await axios.get('/api/profile/fees/');
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getResellerProfileFeeItemList = async () => {
  try {
    const response = await axios.get('/api/profile/buyrates');
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createMerchantFeeItem = async (merchantId, request) => {
  try {
    const response = await axios.post('/api/admin/merchants/fees/' + merchantId, request);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const updateMerchantFeeItem = async (merchantId, feeId, request) => {
  try {
    const response = await axios.put('/api/admin/merchants/fees/' + merchantId + '/' + feeId, request);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const deleteMerchantFeeItem = async (merchantId, feeId) => {
  try {
    const response = await axios.delete('/api/admin/merchants/fees/' + merchantId + '/' + feeId);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const getResellerFeeItemList = async resellerId => {
  try {
    const response = await axios.get('/api/admin/resellers/fees/' + resellerId);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createResellerFeeItem = async (resellerId, request) => {
  try {
    const response = await axios.post('/api/admin/resellers/fees/' + resellerId, request);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const updateResellerFeeItem = async (resellerId, feeId, request) => {
  try {
    const response = await axios.put('/api/admin/resellers/fees/' + resellerId + '/' + feeId, request);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const deleteResellerFeeItem = async (resellerId, feeId) => {
  try {
    const response = await axios.delete('/api/admin/resellers/fees/' + resellerId + '/' + feeId);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deleteResellerPricingTierFeeItem = async (resellerId, feeId) => {
  try {
    const response = await axios.delete(`api/admin/reseller/tiers/${resellerId}/fee/${feeId}`);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getACHInfo = async merchantId => {
  try {
    const response = await axios.get('/api/profile/ach/' + merchantId);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateACHInfo = async (merchantId, request) => {
  try {
    const response = await axios.put('/api/profile/ach/' + merchantId, request);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getBatchTime = async merchantId => {
  try {
    const response = await axios.get('/api/profile/autobatch/' + merchantId);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getBatchTimes = async merchantId => {
  try {
    const response = await axios.get('/api/merchants/' + merchantId + '/autobatchtime');
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateBatchTime = async (merchantId, id, request) => {
  try {
    const response = await axios.put('/api/merchants/' + merchantId + '/autobatchtime/' + id, request);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deleteBatchTime = async (merchantId, id) => {
  try {
    const response = await axios.delete('/api/merchants/' + merchantId + '/autobatchtime/' + id);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createBatchTime = async (merchantId, request) => {
  try {
    const response = await axios.post('/api/merchants/' + merchantId + '/autobatchtime/', request);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getSubuserList = async merchantId => {
  try {
    const response = await axios.get('/api/profile/subusers/' + merchantId);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const createSubuser = async (merchantId, request) => {
  try {
    const response = await axios.post('/api/profile/subusers/' + merchantId, request);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const updateSubuser = async (merchantId, id, request) => {
  try {
    const response = await axios.put('/api/profile/subusers/' + merchantId + '/' + id, request);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const deleteSubuser = async (merchantId, id) => {
  try {
    const response = await axios.delete('/api/profile/subusers/' + merchantId + '/' + id);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createCompGridItem = async (merchantId, request) => {
  try {
    const response = await axios.post('/api/admin/merchants/compgrid/' + merchantId, request);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateCompGridItem = async (merchantId, itemId, request) => {
  try {
    const response = await axios.put('/api/admin/merchants/compgrid/' + merchantId + '/' + itemId, request);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deleteCompGridItem = async (merchantId, itemId) => {
  try {
    const response = await axios.delete('/api/admin/merchants/compgrid/' + merchantId + '/' + itemId);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const getCompGridItemList = async merchantId => {
  try {
    const response = await axios.get('/api/admin/merchants/compgrid/' + merchantId);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const getProcessorInfo = async proc => {
  try {
    const response = await axios.get('/api/admin/merchants/procInfo/' + proc);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getBillsListByStatus = async status => {
  try {
    const response = await axios.get('/api/admin/billing/' + status);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const processBilling = async () => {
  try {
    const response = await axios.post('/api/admin/billing/process', {});
    return response;
  } catch (error) {
    return error.response;
  }
};

export const processAch = async request => {
  try {
    const response = await axios.post('/api/admin/billing/process/ach', request);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const processAchResponse = async () => {
  try {
    const response = await axios.post('/api/admin/billing/process/ach/response', {});
    return response;
  } catch (error) {
    return error.response;
  }
};

export const processResiduals = async () => {
  try {
    const response = await axios.post('/api/admin/billing/process/residuals', {});
    return response;
  } catch (error) {
    return error.response;
  }
};

export const approvalResiduals = async request => {
  try {
    const response = await axios.post('/api/admin/billing/process/approval', request);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const resolveReturns = async request => {
  try {
    const response = await axios.post('/api/admin/billing/resolve/returns', request);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getLocations = async merchantId => {
  try {
    const response = await axios.get('/api/merchants/' + merchantId + '/locations');
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getMerchantList = async () => {
  try {
    const brand = localStorageService.getItem('brandReducer');
    const response = await axios.get('/api/admin/merchants/' + brand.key + '/lite');
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getEpxMerchantList = async () => {
  try {
    const brand = localStorageService.getItem('brandReducer');
    const response = await axios.get('/api/admin/merchants/' + brand.key + '/pgs/lite');
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createLocation = async (merchantId, request) => {
  try {
    const response = await axios.post('/api/merchants/' + merchantId + '/locations', request);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const addLocationMember = async (merchantId, locationId, addMerchantId) => {
  try {
    const response = await axios.post('/api/merchants/' + merchantId + '/locations/' + locationId + '/members', { merchantId: addMerchantId, active: 1 });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deleteLocationMember = async (merchantId, locationId, removeMerchantId) => {
  try {
    const response = await axios.delete('/api/merchants/' + merchantId + '/locations/' + locationId + '/members/' + removeMerchantId);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateLocation = async (merchantId, locationId, request) => {
  try {
    const response = await axios.put('/api/merchants/' + merchantId + '/locations/' + locationId, request);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const disableLocation = async (merchantId, locationId) => {
  try {
    const response = await axios.delete('/api/merchants/' + merchantId + '/locations/' + locationId);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const processTransaction = async (merchantId, params) => {
  try {
    const response = await axios.post('/api/payments/merchant/' + merchantId, params);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const processVaultTransaction = async (merchantId, vaultId, params) => {
  try {
    const response = await axios.post(`/api/vault/${vaultId}/payments`, params);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getAdminSurchargeConfig = async merchantId => {
  try {
    const response = await axios.get('/api/merchants/' + merchantId + '/surcharge/config');
    return response;
  } catch (error) {
    return error.response;
  }
};
export const updateSurchargeConfig = async (merchantId, params) => {
  try {
    const response = await axios.put('/api/merchants/' + merchantId + '/surcharge/config', params);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const addSurchargeRule = async (merchantId, params) => {
  try {
    const response = await axios.post('/api/merchants/' + merchantId + '/surcharge/rules', params);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateSurchargeRule = async (merchantId, ruleId, params) => {
  try {
    const response = await axios.put('/api/merchants/' + merchantId + '/surcharge/rules/' + ruleId, params);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const calcSurcharge = async (merchantId, params) => {
  try {
    const response = await axios.patch('/api/merchants/' + merchantId + '/surcharge/config', params);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const uploadLogo = async (merchantId, fileObj) => {
  try {
    const formData = new FormData();
    formData.append('file', fileObj);
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    };
    const response = await axios.post(`/api/profile/${merchantId}/logo`, formData, config);
    return response;
  } catch (error) {
    return formatError(error);
  }
};
export const getResidualReport = async (resellerId, month, year) => {
  try {
    const response = await axios.get(`api/admin/billing/report/residual/${resellerId}/month/${month}/year/${year}`);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const getIncomeByStateReport = async year => {
  try {
    const brand = localStorageService.getItem('brandReducer');
    const response = await axios.get(`api/admin/merchants/${brand.key}/report/income/state/year/${year}`);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getFraudFirewallList = async merchantId => {
  try {
    const response = await axios.get('/api/fraud/firewall/' + merchantId);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deleteFraudFirewallItem = async (merchantId, apiKeyId) => {
  try {
    const response = await axios.delete('/api/fraud/firewall/' + merchantId + '/' + apiKeyId);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createFraudFirewallItem = async request => {
  try {
    const response = await axios.post('/api/fraud/firewall/' + request.merchantId, request);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateFraudFirewallItem = async request => {
  try {
    const merchId = request.merchantId;
    const ruleId = request.ruleId;
    const response = await axios.put(`/api/fraud/firewall/${merchId}/${ruleId}`, request);
    return response;
  } catch (error) {
    return error.response;
  }
};
